export default "__VITE_ASSET__Do7yjvUi__"